var render = function render(){var _vm=this,_c=_vm._self._c;return _c('GenericDrawer',{attrs:{"colorKey":"bgAppBar","isOpen":_vm.isOpen,"isSubDrawer":true,"topLinks":_vm.topLinks,"bottomLinks":_vm.bottomLinks},on:{"toggle":function($event){return _vm.$emit('toggle', $event)}},scopedSlots:_vm._u([{key:"prepend",fn:function(){return [_c('v-container')]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }